<template>
  <section class="goods">
    <base-container>
      <div class="inner-container">
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              <h4>貨品 1</h4>
            </div>
          </template>
          <div class="form">
            <el-row>
              <el-col :span="24" class="form-control">
                <label for="goodsLink">貨品連結</label>
                <el-input id="goodsLink" placeholder="Goods Link"></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" class="form-control">
                <label for="productName">貨品名稱</label>
                <el-input
                  id="productName"
                  placeholder="Product Name"
                ></el-input>
              </el-col>
              <el-col :span="6" class="form-control">
                <label for="quantity">數量</label>
                <el-input id="quantity" placeholder="Quantity"></el-input>
              </el-col>
              <el-col :span="6" class="form-control">
                <label for="productPrice">貨品價格(USD)</label>
                <el-input
                  id="productPrice"
                  placeholder="Product Price"
                ></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" class="form-control">
                <label for="goodsOrderNumber">貨品訂單編號</label>
                <el-input
                  id="goodsOrderNumber"
                  placeholder="Goods Order Number"
                ></el-input>
              </el-col>
              <el-col :span="12" class="form-control">
                <label for="itemTrackingNumber">貨品追蹤編號</label>
                <small class="text-alert"
                  >請不要在追蹤號數上加上符號或速遞名稱</small
                >
                <el-input placeholder="Please input">
                  <template #prepend>
                    <el-select
                      placeholder="我要填寫追蹤號碼"
                      class="select-input"
                    >
                      <el-option label="Restaurant" value="1"></el-option>
                      <el-option label="Order No." value="2"></el-option>
                      <el-option label="Tel" value="3"></el-option>
                    </el-select>
                  </template>
                </el-input>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" class="form-control">
                <label for="type">類型</label>
                <el-select style="width: 100%" id="type" placeholder="電子產品">
                  <el-option label="Test"></el-option>
                  <el-option label="Test"></el-option>
                  <el-option label="Test"></el-option>
                </el-select>
              </el-col>
              <el-col :span="12" class="form-control">
                <label class="label-select" for="brand">品牌</label>
                <el-select
                  style="width: 100%"
                  id="brand"
                  placeholder="Nintendo"
                >
                  <el-option label="Test"></el-option>
                  <el-option label="Test"></el-option>
                  <el-option label="Test"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" class="form-control">
                <label class="label-select" for="repack">Repack</label>
                <el-radio-group id="repack" v-model="repack">
                  <el-radio label="1" border>是</el-radio>
                  <el-radio label="2" border>否</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :span="12" class="form-control">
                <label for="remarks">備註 (顏色/呎吋大小/特殊要求)</label>
                <el-input
                  id="remarks"
                  type="textarea"
                  placeholder="紅藍色"
                  rows="3"
                ></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-alert
                  title="請填寫實際購買價格及數量方便計算"
                  type="success"
                  effect="dark"
                  :closable="false"
                >
                </el-alert>
              </el-col>
              <el-col :span="24">
                <div class="instructions">
                  <p>代運訂單填寫注意事項：</p>
                  <ul>
                    <li>
                      請確認提供完整的包裹追蹤號碼及物品資訊，並在貨品到達倉庫前提交代運訂單。
                    </li>
                    <li>
                      訂單內物品若有易到家所標示的禁運物品，將會需要進行退貨或轉寄、拋棄，並支付相關費用。有關不同國家之禁運物品，請致電或Whatsapp查詢。
                    </li>
                    <li>
                      請不要在任何欄位加上特殊符號 ( 例如: ~ ! # $ % ^ & * " : ?
                      { } [] | )
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <hr />
            <el-button
              class="add-btn"
              type="primary"
              :icon="Plus"
              circle
            ></el-button>
            <el-row :gutter="20">
              <el-col :span="12" class="w3-right-align">
                <el-button type="primary" class="installation-btn"
                  >重設</el-button
                >
              </el-col>
              <el-col :span="12">
                <el-button type="primary" class="draft-btn">儲存草稿</el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </base-container>
  </section>
</template>

<script>
import { Plus } from "@element-plus/icons-vue";

export default {
  data() {
    return {
      repack: "1",
      Plus: Plus,
    };
  },
};
</script>



<style>
.goods {
  margin-top: 2rem;
}
.goods .inner-container {
  padding: 0 5rem;
}

.goods .el-card {
  border-radius: 12px !important;
}

.goods .el-card__header {
  padding: 0 !important;
}

.goods .card-header {
  background-color: #7a3d87;
  padding: 0.5rem 0.8rem;
}

.goods .card-header h4 {
  margin: 0;
  color: #fff;
  font-weight: 700;
}

.goods .form {
  padding: 0 2rem 3rem 2rem;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.2); */
  position: relative;
}

.goods .form-control {
  margin-bottom: 2rem;
}

.goods .el-input__inner,
.goods .el-textarea__inner {
  border-radius: 8px;
}

/* .goods .el-input__inner:focus {
  border-color: #7a3d87;
} */

.goods .text-alert {
  color: #f65252;
  margin-left: 0.8rem;
}

.goods .el-input-group__prepend {
  width: 160px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  /* border-radius: 8px; */
}

.goods .label-select {
  display: block;
}

.goods .el-radio {
  border-radius: 8px !important;
  padding: 0 7rem 0 0.5rem !important;
  /* width: 50%; */
  margin: 0;
}

.goods .el-radio.is-checked {
  border-color: #666666 !important;
  background-color: #666666;
}

.goods .el-radio__input.is-checked .el-radio__inner {
  background-color: #666666;
  border-color: #fff;
  /* border-width: 0.1rem; */
}

.goods .el-radio__input.is-checked .el-radio__inner::after {
  width: 50%;
  height: 50%;
  /* border-radius: 100%; */
}

.goods .el-radio__input.is-checked + .el-radio__label {
  color: #fff;
}

.goods .el-alert {
  justify-content: center;
  background-color: #f9dc5c !important;
  color: #333333 !important;
  border-radius: 8px !important;
}

.goods .instructions {
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.goods .instructions p {
  margin-bottom: 1rem;
}

.goods .instructions p,
.goods .instructions ul li {
  color: #999999;
}

.goods .instructions ul li {
  margin-left: 2rem;
}

.goods .add-btn {
  position: absolute;
  left: 50%;
  bottom: 14.8%;
  transform: translateX(-50%);
  background-color: #7a3d87;
  border-color: #7a3d87;
}

.goods .el-icon .icon,
.goods .el-icon {
  width: 24px;
  height: 24px;
}

/* .goods .add-btn:hover {
  background-color: #793d87b4;
} */

.goods .el-icon .icon {
  color: #fff;
}

.goods .installation-btn,
.goods .draft-btn {
  border-color: #7a3d87;
  border-radius: 8px;
  padding: 1rem 6rem;
  margin-top: 3rem;
}

.goods .installation-btn {
  background-color: #fff;
  color: #7a3d87;
}

.goods .draft-btn {
  background-color: #7a3d87;
  color: #fff;
}
</style>